import { Component, inject, signal } from '@angular/core';
import { ModalService } from '../../../shared/services/modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mission-success-modal',
  imports: [],
  templateUrl: './mission-success-modal.component.html',
  styles: ``
})
export class MissionSuccessModalComponent {
  
  private ngbActiveModal = inject(NgbActiveModal);
  message = signal<string>('');

  close(){
    this.ngbActiveModal.dismiss('error');
  }
}
